<template>
    <pm-app-component hide-sidebar>

        <template slot="mobile-toolbar">
            <pm-application-bar simple>
               Tutorials
            </pm-application-bar>
        </template>
        <div id="pm-tutorial-grid">
            <pm-tutorial-item v-for="tutorial in tutorials" :item="tutorial" @click.native="play(tutorial)" />
        </div>
        <br/>
    </pm-app-component>
</template>

<style>
    #pm-tutorial-grid {
        /* display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: 16px;
        grid-row-gap: 0px; */
        padding: 16px;
        background: #fff;
    }
</style>

<script>
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmTutorialItem from "./tutorial-item.vue"
import tutorials from "./tutorials.js";

export default {
    components: {
        PmTutorialItem,
    },
    mixins: [
        ToolbarMixin,
    ],
    data: () => {
        return ({
            tutorials: tutorials,
            prevRoute: '/',
        });
    },
    toolbar() {
        const items = [];

            items.push({
                mdi: "mdiHelpCircleOutline",
                text: "Support",
                callback: () => {
                    this.$router.push("/support");
                },
            });

            items.push({
                mdi: "mdiCommentProcessingOutline",
                text: "F.A.Q.",
                callback: () => {
                    this.$router.push("/faq");
                },
            });

            items.push({
                active: true,
                mdi: "mdiHumanMaleBoard",
                text: "Tutorials",
                callback: () => {
                    return false;
                },
            });

            // items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    if (this.prevRoute.path === "/messages") this.$router.push(this.prevRoute);
                    else this.$router.push("/");
                },
            });


        return ([items]);
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    methods: {
        toolbarBack() {
            this.$router.push(this.prevRoute);
        },
        play(item) {
            app.$bus.$emit('openAppDialog','videoPlayer', item);
        }

    },
};
</script>
